<template>
  <EmptyModalBase @close="$emit('close')">
    <div class="p-4">
      <div class="text-lg border-b border-gray-400">
        {{ $t("pages.corona_info.dialog.title") }}
      </div>
      <div class="mt-4 text-sm">
        {{ $t("pages.corona_info.dialog.section1") }}
      </div>

      <object
        class="mt-2"
        height="650"
        width="100%"
        type="application/pdf"
        :data="pdf"
      >
        <p class="text-red-600">PDF cannot be displayed.</p>
      </object>

      <div class="mt-2 text-sm">
        {{ $t("pages.corona_info.dialog.section2") }}
      </div>
      <div class="mt-2 text-sm">
        {{ $t("pages.corona_info.dialog.section3") }}
      </div>
      <div class="mt-2 text-sm">
        {{ $t("pages.corona_info.dialog.section4") }}
      </div>

      <div class="flex justify-end border-t mt-2 pt-4">
        <button
          class="border rounded py-2 px-4 cursor-pointer"
          @click="$emit('close')"
        >
          {{ $t("pages.corona_info.dialog.close") }}
        </button>
      </div>
    </div>
  </EmptyModalBase>
</template>

<script>
import EmptyModalBase from "@/components/shared/EmptyModalBase";
import coronaPlakatPdf from "@/../public/PLAKAT-OGO_LNY.pdf";
export default {
  name: "CoronaModal",
  components: { EmptyModalBase },
  data() {
    return {
      pdf: coronaPlakatPdf
    };
  },
  mounted() {
    this.$ga.page("/corona");
  }
};
</script>

<style scoped></style>
